// FitCenter - Mock Data

export const DISCIPLINES = [
  { id: 'hiit', name: 'HIIT', icon: 'Flame' },
  { id: 'yoga', name: 'Yoga', icon: 'Leaf' },
  { id: 'strength', name: 'Fuerza', icon: 'Dumbbell' },
  { id: 'cycling', name: 'Cycling', icon: 'Bike' },
  { id: 'pilates', name: 'Pilates', icon: 'Sparkles' },
  { id: 'boxing', name: 'Box', icon: 'Target' },
];

export const LEVELS = [
  { id: 'all', name: 'Todos' },
  { id: 'beginner', name: 'Principiante' },
  { id: 'intermediate', name: 'Intermedio' },
  { id: 'advanced', name: 'Avanzado' },
];

export const COACHES = [
  {
    id: 1,
    name: 'Carlos Mendoza',
    specialty: 'HIIT & Fuerza',
    certifications: ['ACE Personal Trainer', 'CrossFit L2', 'TRX'],
    bio: 'Especialista en transformaciones físicas con 8 años de experiencia. Su enfoque combina alta intensidad con técnica impecable.',
    image: 'https://images.pexels.com/photos/35206897/pexels-photo-35206897.jpeg?auto=compress&cs=tinysrgb&w=800',
    rating: 4.9,
    reviews: 234,
    classes: ['HIIT Extreme', 'Fuerza Total', 'Bootcamp'],
  },
  {
    id: 2,
    name: 'Ana Sofía Reyes',
    specialty: 'Yoga & Pilates',
    certifications: ['RYT-500', 'Pilates Mat', 'Prenatal Yoga'],
    bio: 'Instructora certificada con formación en India. Especializada en yoga terapéutico y mindfulness.',
    image: 'https://images.pexels.com/photos/12775213/pexels-photo-12775213.jpeg?auto=compress&cs=tinysrgb&w=800',
    rating: 4.8,
    reviews: 189,
    classes: ['Vinyasa Flow', 'Pilates Core', 'Yoga Restaurativo'],
  },
  {
    id: 3,
    name: 'Diego Ramírez',
    specialty: 'Cycling & Cardio',
    certifications: ['Schwinn Certified', 'Les Mills RPM', 'First Aid'],
    bio: 'Ex-ciclista profesional que trae la energía de la competencia a cada clase. Sus sesiones son legendarias.',
    image: 'https://images.pexels.com/photos/6456141/pexels-photo-6456141.jpeg?auto=compress&cs=tinysrgb&w=800',
    rating: 4.9,
    reviews: 312,
    classes: ['Cycling Power', 'Cardio Blast', 'Endurance'],
  },
  {
    id: 4,
    name: 'Valentina Torres',
    specialty: 'Box & Funcional',
    certifications: ['USA Boxing Coach', 'Kettlebell L2', 'NASM'],
    bio: 'Campeona nacional de box amateur. Sus clases combinan técnica de combate con entrenamiento funcional.',
    image: 'https://images.pexels.com/photos/6740056/pexels-photo-6740056.jpeg?auto=compress&cs=tinysrgb&w=800',
    rating: 4.7,
    reviews: 156,
    classes: ['Box Fitness', 'Kickboxing', 'Functional Training'],
  },
];

// Generate classes for the week
const generateClasses = () => {
  const classes = [];
  const disciplines = ['HIIT', 'Yoga', 'Fuerza', 'Cycling', 'Pilates', 'Box'];
  const levels = ['beginner', 'intermediate', 'advanced', 'all'];
  const durations = [45, 50, 60];
  
  const timeSlots = [
    { time: '06:00', period: 'am' },
    { time: '07:00', period: 'am' },
    { time: '08:30', period: 'am' },
    { time: '10:00', period: 'am' },
    { time: '12:00', period: 'pm' },
    { time: '17:00', period: 'pm' },
    { time: '18:30', period: 'pm' },
    { time: '19:30', period: 'pm' },
    { time: '20:30', period: 'pm' },
  ];

  const classNames = {
    'HIIT': ['HIIT Extreme', 'Tabata Fire', 'Interval Pro'],
    'Yoga': ['Vinyasa Flow', 'Power Yoga', 'Yoga Restaurativo'],
    'Fuerza': ['Fuerza Total', 'Upper Body', 'Lower Body'],
    'Cycling': ['Cycling Power', 'Endurance Ride', 'Hill Climb'],
    'Pilates': ['Pilates Core', 'Pilates Reformer', 'Mat Pilates'],
    'Box': ['Box Fitness', 'Kickboxing', 'Combat Training'],
  };

  // Generate for 7 days
  for (let dayOffset = 0; dayOffset < 7; dayOffset++) {
    const date = new Date();
    date.setDate(date.getDate() + dayOffset);
    
    // 4-6 classes per day
    const numClasses = Math.floor(Math.random() * 3) + 4;
    const usedSlots = new Set();
    
    for (let i = 0; i < numClasses; i++) {
      let slotIndex;
      do {
        slotIndex = Math.floor(Math.random() * timeSlots.length);
      } while (usedSlots.has(slotIndex));
      usedSlots.add(slotIndex);
      
      const discipline = disciplines[Math.floor(Math.random() * disciplines.length)];
      const level = levels[Math.floor(Math.random() * levels.length)];
      const duration = durations[Math.floor(Math.random() * durations.length)];
      const coach = COACHES[Math.floor(Math.random() * COACHES.length)];
      const names = classNames[discipline];
      const name = names[Math.floor(Math.random() * names.length)];
      
      const totalSpots = 12;
      const bookedSpots = Math.floor(Math.random() * 13);
      
      classes.push({
        id: `class-${dayOffset}-${i}`,
        name,
        discipline,
        level,
        duration,
        coach: coach.name,
        coachId: coach.id,
        coachImage: coach.image,
        time: timeSlots[slotIndex].time,
        date: date.toISOString().split('T')[0],
        totalSpots,
        bookedSpots,
        availableSpots: totalSpots - bookedSpots,
        status: bookedSpots >= totalSpots ? 'full' : bookedSpots >= totalSpots - 3 ? 'few' : 'available',
      });
    }
  }
  
  return classes.sort((a, b) => {
    if (a.date !== b.date) return a.date.localeCompare(b.date);
    return a.time.localeCompare(b.time);
  });
};

export const CLASSES = generateClasses();

export const MEMBERSHIPS = [
  {
    id: 'monthly',
    name: 'Mensual',
    price: 1499,
    period: '/mes',
    description: 'Flexibilidad total, cancela cuando quieras',
    features: [
      'Clases ilimitadas',
      'Acceso a todas las disciplinas',
      'Reserva hasta 24h antes',
      'Acceso a app móvil',
      'Cancelación flexible',
    ],
    popular: false,
  },
  {
    id: 'annual',
    name: 'Anual',
    price: 999,
    period: '/mes',
    originalPrice: 1499,
    description: 'Ahorra 33% con compromiso anual',
    features: [
      'Todo lo del plan mensual',
      'Reserva prioritaria',
      '2 clases privadas incluidas',
      'Acceso a eventos exclusivos',
      'Congelamiento 1 mes gratis',
      'Descuento en tienda',
    ],
    popular: true,
    savings: '6,000',
  },
  {
    id: 'paquete',
    name: 'Paquete 10',
    price: 2499,
    period: '',
    description: 'Perfecto para probar sin compromiso',
    features: [
      '10 clases para usar en 60 días',
      'Todas las disciplinas',
      'Sin compromiso mensual',
      'Clases transferibles',
    ],
    popular: false,
  },
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: 'María García',
    age: 32,
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=200&h=200',
    quote: 'En 6 meses perdí 15 kilos y gané una comunidad increíble. Los coaches son lo mejor.',
    goal: 'Pérdida de peso',
    rating: 5,
    beforeAfter: {
      before: 'https://images.pexels.com/photos/6456141/pexels-photo-6456141.jpeg?auto=compress&cs=tinysrgb&w=400',
      after: 'https://images.pexels.com/photos/3756042/pexels-photo-3756042.jpeg?auto=compress&cs=tinysrgb&w=400',
    },
  },
  {
    id: 2,
    name: 'Roberto Sánchez',
    age: 45,
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=200&h=200',
    quote: 'A mis 45 estoy en la mejor forma de mi vida. Las clases de HIIT me cambiaron.',
    goal: 'Ganancia muscular',
    rating: 5,
    beforeAfter: null,
  },
  {
    id: 3,
    name: 'Lucía Fernández',
    age: 28,
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=200&h=200',
    quote: 'El yoga aquí es otro nivel. Ana Sofía es una maestra excepcional.',
    goal: 'Flexibilidad',
    rating: 5,
    beforeAfter: null,
  },
  {
    id: 4,
    name: 'Fernando López',
    age: 35,
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=200&h=200',
    quote: 'La energía de las clases de cycling es adictiva. Perdí 10 kilos sin darme cuenta.',
    goal: 'Pérdida de peso',
    rating: 5,
    beforeAfter: {
      before: 'https://images.pexels.com/photos/4498151/pexels-photo-4498151.jpeg?auto=compress&cs=tinysrgb&w=400',
      after: 'https://images.pexels.com/photos/4498294/pexels-photo-4498294.jpeg?auto=compress&cs=tinysrgb&w=400',
    },
  },
];

export const HOW_IT_WORKS = [
  {
    step: 1,
    title: 'Elige tu clase',
    description: 'Explora el horario y encuentra la clase perfecta para ti.',
    icon: 'Calendar',
  },
  {
    step: 2,
    title: 'Reserva tu lugar',
    description: 'Confirma tu asistencia en segundos desde la app o web.',
    icon: 'CheckCircle',
  },
  {
    step: 3,
    title: 'Entrena y disfruta',
    description: 'Llega, entrena con los mejores coaches y transforma tu vida.',
    icon: 'Sparkles',
  },
];

// Mock user for Account page
export const MOCK_USER = {
  name: 'Sofía',
  lastName: 'Martínez',
  email: 'sofia.martinez@email.com',
  phone: '+52 55 1234 5678',
  membership: 'Anual',
  memberSince: '2024-03-15',
  credits: 8,
  nextRenewal: '2025-03-15',
  upcomingClasses: [
    {
      id: 'booking-1',
      className: 'HIIT Extreme',
      coach: 'Carlos Mendoza',
      date: new Date().toISOString().split('T')[0],
      time: '18:30',
      status: 'confirmed',
    },
    {
      id: 'booking-2',
      className: 'Vinyasa Flow',
      coach: 'Ana Sofía Reyes',
      date: new Date(Date.now() + 86400000).toISOString().split('T')[0],
      time: '10:00',
      status: 'confirmed',
    },
  ],
  waitlist: [
    {
      id: 'waitlist-1',
      className: 'Cycling Power',
      coach: 'Diego Ramírez',
      date: new Date(Date.now() + 172800000).toISOString().split('T')[0],
      time: '19:30',
      position: 2,
    },
  ],
  pastClasses: 47,
};

// WhatsApp number
export const WHATSAPP_NUMBER = '525512345678';
export const WHATSAPP_MESSAGE = 'Hola, me interesa conocer más sobre FitCenter';

export const getWhatsAppLink = (message = WHATSAPP_MESSAGE) => {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
};

// Helper functions
export const getClassesByDate = (date) => {
  return CLASSES.filter(c => c.date === date);
};

export const getClassesByDiscipline = (disciplineId) => {
  if (disciplineId === 'all') return CLASSES;
  return CLASSES.filter(c => c.discipline.toLowerCase() === disciplineId);
};

export const getTodayClasses = () => {
  const today = new Date().toISOString().split('T')[0];
  return CLASSES.filter(c => c.date === today);
};

export const getTomorrowClasses = () => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  return CLASSES.filter(c => c.date === tomorrow.toISOString().split('T')[0]);
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('es-MX', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  });
};

export const formatShortDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('es-MX', {
    weekday: 'short',
    day: 'numeric',
  });
};
